import React from 'react';

const PieChart = ({
  data,
  colors,
  size = 150,
  fill = false,
}: {
  data: any;
  colors: any;
  size?: number;
  fill?: boolean;
}) => {
  const total = data.reduce((sum: any, value: any) => sum + value, 0);
  let accumulatedPercentage = 0;

  const gradientParts = data.map((value: any, index: any) => {
    const percentage = (value / total) * 100;
    const startAngle = accumulatedPercentage * 3.6;
    const endAngle = (accumulatedPercentage + percentage) * 3.6;
    accumulatedPercentage += percentage;
    return `${colors[index]} ${startAngle}deg ${endAngle}deg`;
  });

  return (
    <div
      className={`relative flex items-center justify-center rounded-full ${fill ? 'h-full w-full' : ''}`}
      style={{
        width: fill ? '100%' : size,
        height: fill ? '100%' : size,
        background: `conic-gradient(${gradientParts.join(', ')})`,
      }}
    >
      <div
        className="absolute rounded-full bg-white"
        style={{
          width: fill ? '50%' : size / 2,
          height: fill ? '50%' : size / 2,
        }}
      />
    </div>
  );
};

export default PieChart;
